import React from 'react'
import SelectField from '../input/SelectField'
import { Typography } from '@mui/material'

export const SelectFieldServiceSSO = ({ id, onChange, name, value, error, disabled, isPreview }) => {
  const options = [
    { value: 'google', label: 'Google' },
    { value: 'microsoft', label: 'Microsoft' },
    { value: 'cloudwork', label: 'Cloudwork' },
  ]
  if (isPreview) {
    return (
      <Typography>{options.find((op) => op.value === value)?.label}</Typography>
    )
  }

  return (
    <SelectField
      id={id}
      error={error}
      helperText={error}                    
      value={value || ''}
      name={name}
      onChange={onChange}      
      options={options}
      placeholder="Choose a service"
      disabled={disabled}
    />  
  )
}
